import {  Observable, throwError, forkJoin, of } from 'rxjs';
//import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, map, switchMap, tap, retry} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
//import {HttpClient,HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpHeaders} from '@angular/common/http';
//import { Http, Response, 
//        Headers, RequestOptions, RequestMethod , ResponseContentType}   from '@angular/http';

//import { tokenNotExpired } from 'angular2-jwt';
import { AuthService }    from '../auth/ind/auth.service';
//import './rxjs-operators';
import { environment }    from '../../environments/environment';
//import { JwtHelper }      from 'angular2-jwt';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Credentials, User, Scope, Ops, Referral,MIN_REFERRERS,EN_US_MONTHNAMES }    from '../_models/index';
//import { error } from 'console';
//import { NgFlashService } from 'ng-flash';
//import { ToastrModule } from 'ngx-toastr';

//import { Reference }                from '../model/reference.interface';


@Injectable()
export class ReferralService {
    private cachedIndHomeData: [any[], any[]] | null = null;
    constructor(private httpClient: HttpClient, private auth: AuthService, private JwtHelperService: JwtHelperService)
//,private toastr: ToastrService  //this.toastr.success('Saved successfully');
    //,  private _ngFlashService: NgFlashService 
{     }
     private apiUrl = environment.apiurl;
     private referralUrl = environment.gdocsurl;

getReferralInd(referencetype: string, numReferrals: number | string): Observable<[any[], any[]]> {
        return this.getReferral(referencetype, numReferrals, Scope.BF_ENT);
}

getCachedReferralInd(): [any[], any[]] | null {
        return this.cachedIndHomeData;
}

clearCachedReferralInd(): void {
        this.cachedIndHomeData = null;
}

private getReferral(referencetype: string, numReferrals: number | string, scope: Scope): Observable<[any[], any[]]> {
//private getReferral(referencetype, numReferrals, scope):Observable<[any]>{
        if (!this.auth.loggedIn()){  return throwError(() => new Error('Not authenticated')); }
        var referencetypeSelf = "Self"; // console.log('In getReferral');
        //var body = '{ "id_token":"'+this.auth.id_token+'", "ops":"'+ Ops.GETREFERRAL +'", "scope":"'+user.scope+'" , "entid":"'+user.id+'" }';        
        //var body = '{ "id_token":"'+this.auth.user.id_token+'", "ops":"'+ Ops.GETREFERRAL +'", "scope":"'+Scope.BF_ENT+'" }';
        //var user:User = this.auth.currentUserValue;
        var id_token = this.auth.currentUserValue.id_token; //console.log('Id_token value1:'+id_token);
        var body = {id_token:'', ops: '',  numReferrals:'', scope: ''};
        //var body = '{ "id_token":"'+id_token+'", "ops":"'+ Ops.GETREFERRAL +'", "numReferrals":"'+ numReferrals +'", "scope":"'+scope+'" }';
        body.id_token = (id_token !== undefined) ? id_token : "";
        body.ops = (Ops.GETREFERRAL.toString() !== undefined) ? Ops.GETREFERRAL.toString() : "";
        body.numReferrals = (numReferrals !== undefined) ? numReferrals.toString() : "";
        body.scope = (scope !== undefined) ? scope.toString() : "";
        //console.log('Before getReferral post:'+this.referralUrl+' Body: '+JSON.stringify(body));
       //alert ('Body'+body);
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        //return this.httpClient.post(this.referralUrl, body, {headers}).pipe(
        return this.httpClient.post(this.referralUrl, body, {headers}).pipe(
        map((r : any) => 
                { //alert('headers: '+JSON.stringify(res.));
                  //console.log('getReferral response:', JSON.stringify(r));
                        if (r.status == "200"){
                                sessionStorage.setItem('onreference_reuse_ind-home', "1");
                                var result = Array.isArray(r.result) ? r.result : [];
                                var newArrSel: any[] = [];
                                var newArrOth: any[] = [];
                                var len = Object.keys(result).length;
                                for(var i = 0; i < len ; i++)
                                {  
                                let newArr: any[] = [];
                                newArr.push(result[i]);//newArr.push(JSON.parse(result[i]));
                                const referralItem = newArr[0];
                                var tmpReferrers = result[i].referrers;
                                //var lenReferrers = Object.keys(tmpReferrers).length;
                                var referrersArr: any[] = [];
                                var MainrefReferrerNotResponded = false;                                        
                                for(var j in tmpReferrers){
                                        if (tmpReferrers[j]['CreatedBy'] == "Mainref" && tmpReferrers[j]['ReferrerStatus'] != "RESPONDED" ){
                                                MainrefReferrerNotResponded = true;
                                        }
                                        tmpReferrers[j]['canDelete'] = "0";//TODO logic for showing trash button                                         
                                        /*if (tmpReferrers[i]['referencetype'] == "Organization" && tmpReferrers[j]['ReferrerStatus'] != "RESPONDED"){
                                                tmpReferrers[i]['canDelete'] = "1";
                                        }else{
                                                tmpReferrers[i]['canDelete'] = "0";
                                        }*/                                                                                                
                                        referrersArr.push(tmpReferrers[j]);
                                }
                                referralItem['referrers'] = referrersArr;
                                //delete result[i]['referrersList'];
                                //newArr.push(result[i]);//newArr.push(JSON.parse(result[i]));                                                                                                                                                                
                                /*newArr[i]['startdate'] = newArr[i]['startdate'].substring(8,10)
                                + '-' + EN_US_MONTHNAMES[parseInt(newArr[i]['startdate'].substring(5,7))-1]
                                + '-' + newArr[i]['startdate'].substring(0,4);
                                newArr[i]['finishdate'] = newArr[i]['finishdate'].substring(8,10)
                                + '-' + EN_US_MONTHNAMES[parseInt(newArr[i]['finishdate'].substring(5,7))-1]
                                + '-' + newArr[i]['finishdate'].substring(0,4);

                                newArr[i]['enddate'] = newArr[i]['enddate'].substring(8,10)
                                + '-' + EN_US_MONTHNAMES[parseInt(newArr[i]['enddate'].substring(5,7)) - 1]
                                + '-' + newArr[i]['enddate'].substring(0,4);*/
                                type ActionType = 'VIEW' | 'PENDING' | 'READY' | 'VIEWREPORT' | 'ADDREFERRERS';
                                let action: ActionType = 'VIEW';

                                const actiontext: Record<ActionType, string> = {
                                        VIEW: '(View...)',
                                        PENDING: '(Pending...)',
                                        READY: '(Wait for Completion...)',
                                        VIEWREPORT: '(View Report...)',
                                        ADDREFERRERS: '(Add Referees...)'
                                };
                                
                                const actionColor: Record<ActionType, string> = {
                                        // go to detail page
                                        VIEW: 'BLUE',
                                        PENDING: 'RED',
                                        READY: 'GREEN',
                                        // go to report page
                                        VIEWREPORT: 'BLUE',
                                        // go to add referrers page
                                        ADDREFERRERS: 'RED'
                                };
                                switch (referralItem['status']){
                                        case 'NOTSTARTED':                                                
                                                action = 'PENDING';
                                                break;
                                        case 'COMPLETED':
                                                action = 'VIEWREPORT';
                                                break;                                                        
                                        case 'STARTED':
                                                //if (newArr[i]['totalresponses'] >= MIN_REFERRERS && MainrefReferrerNotResponded != true){
                                                if (referralItem['action'] == 'READY' && MainrefReferrerNotResponded != true ){
                                                        action = 'READY';
                                                }else{
                                                        if (referralItem['totalinvited'] < MIN_REFERRERS){
                                                                action = 'ADDREFERRERS';
                                                        }else{
                                                                action = 'VIEW';
                                                        }                                                         
                                                }
                                                break;                                                        
                                        default:
                                                action = 'VIEW';
                                }
                                referralItem['action'] = action;
                                referralItem['actionText'] = actiontext[action];
                                referralItem['actionColor'] = actionColor[action];

                                //alert ('Newarr:'+JSON.stringify(newArr));
                                //alert (newArr[i]['referencetype']);
                                if ( referralItem['referencetype'] == referencetype ){
                                        //alert (newArr[i]['referencetype']);
                                        newArrSel.push(referralItem);
                                }else{
                                        if ( referralItem['referencetype'] == referencetypeSelf){
                                                newArrOth.push(referralItem);
                                        }else{
                                                // do nothing dont add anywhere
                                        }
                                        }
                                }//alert ('Newarr1:'+JSON.stringify(newArrSel));
                                this.cachedIndHomeData = [newArrSel, newArrOth];
                                return [newArrSel, newArrOth];
                        }else{//alert('Return status code: '+JSON.stringify(result));
                                console.log('getReferral non-200 payload:', JSON.stringify(r));
                                //TODO Sign Out - Token expired due to auth restart or time delay
                                if (r.status == "400"){
                                //ErrorObservable.create((JSON.stringify(r)) ? (r.status) : 'Please Sign Out and Sign In. Session timedout.');
                                throw new Error((JSON.stringify(r)) ? (r.status) : 'Please Sign Out and Sign In. Session timedout.');


                                //alert('Please relogin. Session timedout.');
                                //this._flashMessagesService.show('Please Sign Out and Sign In. Session timedout.', { cssClass: 'alert-success', timeout: 10000 });
                                //this._ngFlashService.success('Please Sign Out and Sign In. Session timedout.');
                                this.auth.logout;
                                }else{
                                //ErrorObservable.create((JSON.stringify(r)) ? (r.status) : 'Please Sign Out and login. Unknown error.'+JSON.stringify(r));
                                throw new Error((JSON.stringify(r)) ? (r.status) : 'Please Sign Out and login. Unknown error.'+JSON.stringify(r));
                                //this._flashMessagesService.show('Please Sign Out and Sign In. Unknown error.'+r.status, { cssClass: 'alert-success', timeout: 10000 });
                                //this._ngFlashService.success('Please Sign Out and Sign In. Session timedout. Unknown error');
                                //alert('Please relogin. Unknown error.'+r.status);
                                this.auth.logout;
                                }
                                return [[],[]];
                        }
                }), 
                //.map(mapReferrals)
                //.map<Referral[]>((res:Response) => res.json()) 
                //.catch((error:any) => alert('ERROR: '+error))
                //retry(1),
                //catchError((err:any, caught: Observable<any>) => ErrorObservable.create((err) ? (err) : 'Server error: '+err.text()) ),);
                catchError((err:any, caught: Observable<any>) => {
                        console.log('getReferral error:', err);
                        return throwError(() => (err) ? (err) : 'Server error: '+err?.text?.());
                }))
}

createReferral (body: string): Observable<any> {
        if (!this.auth.loggedIn()){  return throwError(() => new Error('Not authenticated')); }
        //sessionStorage.removeItem('onreference_reuse_ind-home');
        //const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        //return this.httpClient.post(this.referralUrl, body, {headers}).pipe( // ...using post request
        
        /*return this.httpClient.post(this.referralUrl, body, {headers}).pipe( // ...using post request
           map((res: any) => {return res;}), // ...and calling .json() on the response to return data
           catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);*/
        var id_token = this.auth.currentUserValue.id_token;
        var refData = {env: "", cacheStr:"", body: "", token: ""};
        var cachestr = "CM" + Date.now() + "_" + Math.floor(Math.random() * 1000000);
			//cache.put(cacheStr, JSON.stringify(body), 21598);
        refData.env = environment.envname;
        refData.cacheStr = cachestr;
        refData.body = body;
        refData.token = id_token;
        return this.httpClient.post(this.apiUrl+'entity/createEntityReferral', refData, this.getHeaderOptions(id_token)).pipe(map((response: any) => response));
}

createReferrers (objBody: any): Observable<any> {
        if (!this.auth.loggedIn()){  return throwError(() => new Error('Not authenticated')); }
        sessionStorage.removeItem('onreference_reuse_ind-home');
        //var id_token = this.auth.currentUserValue.id_token;
        /*var body =  '{ "id_token":"'+id_token+'", "ops":"5", "scope":"2", "entid":"1", "referenceid":"1" , "entity":{"email":"cand@ideamindsoft.com","phone":"123 456 7890","prefix":"Mr","firstname":"candf","lastname":"candl"}, "raters":[{"email":"rater1@ideamindsoft.com","phone":"123 456 7890","prefix":"Mr","firstname":"raterfirst","lastname":"raterlast"},{"email":"rater2@ideamindsoft.com","phone":"123 456 7892","prefix":"Dr.","firstname":"raterfirst2","lastname":"raterlast2"}]}';*/
        //{\"email\":\"emp@ideamindsoft.com\", \"scope\":\"2\", \"pwd\":\"test123\", \"sessionId\":\"s1234\", \"referenceid\":1 , \"entid\": 1, \"entity\":{\"email\":\"cand@ideamindsoft.com\",\"phone\":\"123 456 7890\",\"prefix\":\"Mr\",\"firstname\":\"candf\",\"lastname\":\"candl\"}, \"raters\":[{\"email\":\"rater1@ideamindsoft.com\",\"phone\":\"123 456 7890\",\"prefix\":\"Mr\",\"firstname\":\"raterfirst\",\"lastname\":\"raterlast\"},{\"email\":\"rater2@ideamindsoft.com\",\"phone\":\"123 456 7892\",\"prefix\":\"Dr.\",\"firstname\":\"raterfirst2\",\"lastname\":\"raterlast2\"}]}
        var body = JSON.stringify(objBody);
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        //return this.httpClient.post(this.referralUrl, body, {headers}).pipe( // ...using post request
        return this.httpClient.post(this.referralUrl, body, {headers}).pipe( // ...using post request        
            map((res: any) => {return res;}), // ...and calling .json() on the response to return data
            //catchError((err:any, caught: Observable<any>) => ErrorObservable.create((err) ? (err) : 'Server error: '+err.text()) ),);            
            catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);
            //.catch<Referral[]>((error:any) => {Observable.throw(error.json().error || 'Server error')}); //...errors if any
}

generateReport (body: string): Observable<Referral[]> {
        if (!this.auth.loggedIn()){  return throwError(() => new Error('Not authenticated')); }
        sessionStorage.removeItem('onreference_reuse_ind-home');
        var id_token = this.auth.currentUserValue.id_token;
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        //return this.httpClient.post(this.referralUrl, body, this.getHeaderOptions(id_token)).pipe( // ...using post request
        return this.httpClient.post(this.referralUrl, body, {headers} ).pipe( // ...using post request                
           map((res:any) => {return res;}), // HttpClient already returns parsed JSON
           catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);            
}

getReport (body: string): Observable<any> {
        if (!this.auth.loggedIn()){  return throwError(() => new Error('Not authenticated')); }
        var id_token = this.auth.currentUserValue.id_token;
         //var id_token = sessionStorage.getItem('onreference_ent_token'); //TODO put in try catch ?

        //let bodyString = JSON.stringify(body); // Stringify payload
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.httpClient.post(this.referralUrl, body, {headers}).pipe( // ...using post request
            map((res:any) => {return res;}), // ...and calling .json() on the response to return data
            //retry(1),
            catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);            
            //.catch<Referral[]>((error:any) => {Observable.throw(error.json().error || 'Server error')}); //...errors if any
 }

getPDF(body: any): Observable<Blob>{
        if (!this.auth.loggedIn()){  return throwError(() => new Error('Not authenticated')); }
        var id_token = this.auth.currentUserValue.id_token ?? '';
        //return this.httpClient.post(this.apiUrl+'mainref/getPDF', body, this.jwt(this.authOrg.user.id_token))
        /*let headers = new Headers();
        headers.append('Authorization', this.authOrg.user.id_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        var requestOptions = new RequestOptions({ headers: headers });*/
        return this.httpClient.post(this.apiUrl+'entity/getPDF', body, 
                {
                        responseType: "blob",
                        headers: new HttpHeaders(
                        {'Content-Type': 'application/json', 'Authorization': id_token})
                }).pipe(                        
            map((response: Blob) =>  
                {   return new Blob([response], { type: 'application/pdf' }); }
               ),
            //retry(1),
            catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);
    }

addFreePoints (objBody:any): Observable<[any]> {
        if (!this.auth.loggedIn()){  return throwError(() => new Error('Not authenticated')); }
        var body = JSON.stringify(objBody);
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.httpClient.post(this.referralUrl, body, {headers}).pipe( // ...using post request
           map((res:any) => {return res;}), // ...and calling .json() on the response to return data
           catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);            
}

/*remindReferrers (objBody:any): Observable<[any]> {
        if (!this.auth.loggedIn()){  return throwError(() => new Error('Not authenticated')); }
        //sessionStorage.removeItem('onreference_reuse_ind-home');
        //var id_token = this.auth.currentUserValue.id_token;
        var body = JSON.stringify(objBody);
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.httpClient.post(this.referralUrl, body, {headers}).pipe( // ...using post request
           map((res:any) => {return res;}), // ...and calling .json() on the response to return data
           catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);            
}*/
remindReferrers(body: any): Observable<any> {
        if (!this.auth.loggedIn()) {
                return throwError(() => new Error('Not authenticated'));
        }

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        //const body    = JSON.stringify(objBody);

        const remind$ = this.httpClient.post(this.referralUrl, body, { headers }).pipe(
        map((res: any) => res),
        catchError((err: any) => throwError(() => err || 'Server error'))
        );

        const parsedBody = typeof body === 'string' ? JSON.parse(body) : body;

        const fsBody = JSON.stringify({
        ops:       'updateFirestoreStatus',
        id_token:  parsedBody.id_token,
        referralid: parsedBody.referralid,
        status:    'reminderSent'
        });

        const firestore$ = this.httpClient.post(this.referralUrl, fsBody, { headers }).pipe(
        map((res: any) => res),
        catchError((err: any) => {
        // Non-fatal — log but don't fail the whole operation
        console.warn('Firestore update failed:', err);
        return of({ status: 'fs_error', error: err });
        })
        );

  // ── Run both and return combined result ──────────────────────
        return forkJoin([remind$, firestore$]).pipe(
        map(([remindResult, fsResult]) => {
        return {
                ...remindResult,
                firestoreUpdate: fsResult
        };
        }),
        catchError((err: any) => throwError(() => err || 'Server error'))
        );
}


private getHeaderOptions(id_token: string): { headers: HttpHeaders } {
        const httpOptions = {
                headers: new HttpHeaders({
                        'Content-Type': 'application/json',
                        ...(id_token && id_token !== "" && { Authorization: 'Bearer ' + id_token })
                })
        };
        return httpOptions;
}
   
}
